var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavorites = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1731 5.59964C15.3881 3.79794 14.3031 1.67974 11.9932 1.6029C10.4532 1.55167 9.12827 2.35059 8.01825 3.99964C6.83058 2.40181 5.50561 1.6029 4.04333 1.6029C1.84991 1.6029 0.482104 3.6384 0.863394 5.59964C1.11759 6.90712 3.50254 9.84046 8.01825 14.3996C12.6448 9.7341 15.0298 6.80077 15.1731 5.59964Z",
    stroke: "#EF3D3D",
    strokeWidth: 1.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavorites);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/favorites.2dc3b28bdf28127ad55f52db91f37f04.svg";